import { useMutation, useQueryClient } from '@tanstack/react-query';
import http from 'helpers/requests';
import { cgToast, notifyError } from 'modules/Common/ui/toast';
import { useFreemium } from 'modules/Common/freemium/FreemiumContext';

export const useCreateOperatorInstallation = ({ silent = false } = {}) => {
  const queryClient = useQueryClient();
  const { triggerLimitExceeded } = useFreemium();

  return useMutation({
    mutationFn: async (installationData) => {
      const response = await http.post('/installations/operator/add', installationData);
      return response.data;
    },
    onSuccess: () => {
      cgToast.success('Success', { description: 'Installation created successfully' });
      triggerLimitExceeded();
      queryClient.invalidateQueries({ queryKey: ['operatorInstallations'] });
    },
    // D11 (one failure, one voice): callers that render their own error
    // surface pass { silent: true } — e.g. the COMMS template flow's banner.
    onError: silent ? undefined : notifyError,
  });
};
